// Simple countdown timer. Fires onTick every second and onDone when it reaches zero.

let intervalId = null

export function start(seconds, { onTick, onDone }) {
  stop()
  let remaining = seconds

  intervalId = setInterval(() => {
    remaining -= 1
    onTick()
    if (remaining <= 0) {
      stop()
      onDone()
    }
  }, 1000)
}

export function stop() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
}

export const isRunning = () => intervalId !== null
